<template>
  <div class="bind-wechat-qrcode">
    <div v-if="loading" class="wechat-state">
      <a-spin />
      <p>正在获取绑定二维码...</p>
    </div>

    <div v-else-if="expired" class="wechat-state">
      <p>二维码已过期</p>
      <a-button type="primary" @click="emit('refresh')">
        刷新二维码
      </a-button>
    </div>

    <div v-else class="wechat-content">
      <img v-if="qrcodeUrl" :src="qrcodeUrl" alt="绑定微信二维码" class="wechat-qrcode" />
      <p class="wechat-tip">请使用微信扫一扫完成绑定</p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  qrcodeUrl: string
  loading: boolean
  expired: boolean
}>()

const emit = defineEmits<{
  refresh: []
}>()
</script>

<style lang="scss" scoped>
.bind-wechat-qrcode {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wechat-state,
.wechat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.wechat-qrcode {
  width: 220px;
  height: 220px;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.wechat-tip {
  color: var(--text-secondary, #ccc);
}
</style>
